import { render, staticRenderFns } from "./AcessosPorPagina.vue?vue&type=template&id=27ad008f&scoped=true"
import script from "./AcessosPorPagina.vue?vue&type=script&lang=js"
export * from "./AcessosPorPagina.vue?vue&type=script&lang=js"
import style0 from "./AcessosPorPagina.vue?vue&type=style&index=0&id=27ad008f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ad008f",
  null
  
)

export default component.exports